		/**
		 * @ngdoc service
		 * @name WcResponsiveTableModule.service:WcTablePaginationService
		 * @requires WcTableCollectionService
		 * @description
		 * The WcTablePaginationService manages the pagination operations, this service is responsible for all pagination methods.
		 * All pagination action will come through this service.
		 */



angular.module('WcResponsiveTableModule')
	.factory('WcTablePaginationService', function() {

        function WcTablePaginationService(WcTableCollectionService) {
        	this.WcTableCollectionService = WcTableCollectionService;
			this.collectionLength = this.WcTableCollectionService.getCollectionLength();

            this.paginationEnabled = false;

            this.paginationDefaults = {
                pageStart: 0,
                pageEnd: 10,
                resultsPerPage: 10,
                numberOfPageControls: 5,
                selectResultsPerPage: [10, 25, 50, 100],
                responsiveBreakpoints: [430, 500, 600, 900],
                paginationControlsPlacement: 'both'
            };
        }

		/**
		 * @ngdoc method
		 * @name getPaginationDefaults
		 * @methodOf WcResponsiveTableModule.service:WcTablePaginationService
		 * @returns {json} This json holds pagination default values
		 * @description
		 * This method is to get the pagination default values.
		 */

		WcTablePaginationService.prototype.getPaginationDefaults = function () {
			if (this.paginationEnabled) {
				return angular.copy(this.paginationDefaults);
			} else {
				// var collectionLength = this.WcTableCollectionService.getCollectionLength();
				return {
					pageStart: 0,
					pageEnd: this.collectionLength
				};
			}
		};

		/**
		 * @ngdoc method
		 * @name isPaginationEnabled
		 * @methodOf WcResponsiveTableModule.service:WcTablePaginationService
		 * @returns {boolean} This boolean value returns a true or false.
		 * @description
		 * This method is to set the pagination option for datatable.
		 */

		WcTablePaginationService.prototype.isPaginationEnabled = function () {
			return this.paginationEnabled;
		};

		/**
		 * @ngdoc method
		 * @name setPaginationDefaults
		 * @methodOf WcResponsiveTableModule.service:WcTablePaginationService
		 * @param {json} newDefaults The json string holds the new default values for pagination
		 * @description
		 * This method is to set the pagination default values.
		 */

		WcTablePaginationService.prototype.setPaginationDefaults = function (newDefaults) {
			for (var property in newDefaults) {
				if (this.paginationDefaults[property] !== 0 && !this.paginationDefaults[property]) {
					console.error('WcTablePaginationService: setPaginationDefaults(); Property ' + property + ' is not a pagination default');
					//remember that 0 is a valid possibility
				} else if (newDefaults[property] || (typeof newDefaults[property] == 'number' && newDefaults[property] > -1)) {
					this.paginationDefaults[property] = newDefaults[property];
				}
			}
		};

		/**
		 * @ngdoc method
		 * @name setPaginationState
		 * @methodOf WcResponsiveTableModule.service:WcTablePaginationService
		 * @param {boolean} boolean This boolean value returns a true or false.
		 * @description
		 * This method is to set the pagination enabled option for datatable
		 */
		WcTablePaginationService.prototype.setPaginationState = function (boolean) {
			this.paginationEnabled = boolean;
		};

        return WcTablePaginationService;
	});